import { Box, Typography } from '@atgfr8/atg-ui-tailwind';
import { BasicModal, Button } from '@components';
import { closeModal, openModal } from '@store/modals';
import {
  computeTotalLineItems,
  orderStore,
  updateOrderState,
} from '@store/orders';
import { userStore } from '@store/user/store';

import {
  CreditIncreaseRequestModalId,
  setAcceptedLiability,
} from './CreditIncreaseRequestModal';

export const CreditAcknowledgementModalId = 'CreditAcknowledgementModal';

export const CreditAcknowledgementModal = () => {
  const recordLiabilityDecision = (userAcceptedLiability: boolean) => {
    updateOrderState({
      negativeCreditLiabilityDecision: {
        orderId: orderStore.order.id,
        customerId: orderStore.order.customerId ?? 0,
        customerPay: computeTotalLineItems(),
        userAcceptedLiability,
        negativeCreditAcceptanceDateTime: new Date().toISOString(),
        acceptedByUserId: userStore.user.id,
        acceptedByUserName: userStore.user.name,
      },
    });
  };

  const handleClose = () => {
    setAcceptedLiability(false);
    recordLiabilityDecision(false);
    closeModal(CreditAcknowledgementModalId);
  };

  const handleAcceptLiability = () => {
    setAcceptedLiability(true);
    recordLiabilityDecision(true);
    closeModal(CreditAcknowledgementModalId);
    openModal(CreditIncreaseRequestModalId);
  };

  const handleNotAcceptLiability = () => {
    setAcceptedLiability(false);
    recordLiabilityDecision(false);
    closeModal(CreditAcknowledgementModalId);
    openModal(CreditIncreaseRequestModalId);
  };

  return (
    <BasicModal
      id={CreditAcknowledgementModalId}
      customizedHeaderContent={
        <span class="text-primary font-semibold">
          Credit Limit Acknowledgement
        </span>
      }
      width="520px"
      footer={false}
      showClose
      onClose={handleClose}
    >
      <Box class="flex flex-col gap-2 pt-2">
        <Box class="flex flex-col gap-1">
          <Typography variant="body1">
            This order will cause the customer’s available credit to fall below
            $0. By accepting, you acknowledge and accept responsibility for the
            resulting negative credit balance as Agent Liability.
          </Typography>
          <Typography variant="body1" class="font-bold!">
            Please confirm how you would like to proceed:
          </Typography>
        </Box>
        <Box class="flex items-center justify-start gap-3">
          <Button
            variant="contained"
            color="warning"
            label="Accept Liability"
            onClick={handleAcceptLiability}
            dataTestId="creditAcknowledgement-acceptLiability-button"
          />
          <Button
            variant="contained"
            color="primary"
            label="Do Not Accept"
            onClick={handleNotAcceptLiability}
            dataTestId="creditAcknowledgement-doNotAccept-button"
          />
        </Box>
        <Typography variant="caption" class="text-[#666666]">
          If you do not accept, you can request a credit limit increase. Closing
          this modal without selecting an option will be treated as
          non-acceptance.
        </Typography>
      </Box>
    </BasicModal>
  );
};
